/** @module csi/widget/SvgColorPalette */
define([
	"dojo/_base/declare",
	"dojo/i18n",
	"dojo/colors",
	"dijit/ColorPalette",
	"csi",
	"underscore"
], function(declare,i18n,colors,ColorPalette,csi,_) {

	var TRANSPARENT = "transparent";

	return declare(ColorPalette, {
		TRANSPARENT: TRANSPARENT,

		/** @property {boolean} bSupportTransparent - set to false if transparent color should not be available */
		bSupportTransparent: true,

		constructor: function(param) {
			if(param && param.newColors) {
				this.addColorsToPalette(param.newColors);

				this._palettes["7x10"][7] = [];
				_.each(param.newColors, function(val){
					this._palettes["7x10"][7].push(val.name);
				},this);
			}
		},

		addColorsToPalette: function(values) {
			var title = i18n.getLocalization("dojo", "colors", "");

			_.each(values,function(val){
				if(!colors.named[val.name]) {
					colors.named[val.name] = val.value;
					title[val.name] = val.name;
				}
			})
		},

		_preparePalette: function(choices, titles) {
			// summary: add transparent to palette
			if (this.bSupportTransparent) {
				choices = [].concat(choices);
				choices[0] = [].concat(choices[0]);
				choices[0][0] = TRANSPARENT;
				choices[0][1] = "white";

				// DOJO INTERNAL - reference ColorPalette.buildRendering
				this._dyeClass = declare(ColorPalette._Color, {
					palette: this.palette,

					fillCell: function(cell, blankGif) {
						if (this._row == 0 && this._col == 0) {
							blankGif = csi.image("TransparentColor.png");
						}
						this.inherited(arguments, [cell, blankGif]);
					},

					toHex: function() {
						return (this._row == 0 && this._col == 0) ? TRANSPARENT : this.inherited(arguments);
					}
				});
			}

			this.inherited(arguments, [choices, titles]);
		}
	});
});